import axios from "@/api";
import { getCompany } from "@/publicjs/company";
import { imageInBase64 } from "@/publicjs/logoCompany";

const companyCache = new Map();
const logoCache = new Map();

const getAccessStoreId = () => {
  const accessData = JSON.parse(localStorage.getItem("access") || "null");
  return accessData?.user?.store ?? null;
};

const getCachedCompany = (storeId) => {
  if (!companyCache.has(storeId)) {
    companyCache.set(storeId, getCompany(storeId));
  }

  return companyCache.get(storeId);
};

const getCachedLogo = (logoUrl) => {
  if (!logoUrl) {
    return Promise.resolve(null);
  }

  if (!logoCache.has(logoUrl)) {
    logoCache.set(logoUrl, imageInBase64(logoUrl));
  }

  return logoCache.get(logoUrl);
};

const getOrder = async (idOrder) => {
  const response = await axios.get(`ventas/print/${idOrder}`);

  if (response.msg === false) {
    return [];
  }

  return response?.data ?? [];
};

export const loadSalePrintContext = async (idOrder) => {
  const storeId = getAccessStoreId();

  if (!storeId) {
    throw new Error("No se pudo identificar la sucursal de la sesion actual.");
  }

  const [company, registers] = await Promise.all([
    getCachedCompany(storeId),
    getOrder(idOrder),
  ]);

  const base64Image = await getCachedLogo(company?.companyLogo);

  return {
    company,
    registers,
    base64Image,
  };
};
